import PropTypes from 'prop-types';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {Box, Divider, Grid, Tab, Tabs, Typography} from '@mui/material';
import MainCard from '../../components/berry/ui-component/cards/MainCard';
import { gridSpacing } from 'store/appConstant';
import React from "react";
import {useSelector} from "react-redux";
import PersonnalDataEditForm from "../../components/extranet/user/form/PersonnalDataEditForm";
import EmailEditForm from "../../components/extranet/user/form/EmailEditForm";
import PasswordEditForm from "../../components/extranet/user/form/PasswordEditForm";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import EmailIcon from '@mui/icons-material/Email';
import DefaultLayout from "../../components/layout/DefaultLayout";

// tabs panel
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

// tabs option
const tabsOption = [
    {
        label: 'Mes coordonnées',
        icon: <AssignmentIndIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
        label: 'Ma connexion',
        icon: <EmailIcon sx={{ fontSize: '1.3rem' }} />
    }
];

// ==============================|| PROFILE 1 ||============================== //

const Profile = () => {
    const theme = useTheme();

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const account = useSelector(state => state.account);
    const [editMode , setEditMode] = React.useState(false);
    return (
        <DefaultLayout>
        <Box sx={{p: 2, bgcolor: 'transparent', borderRadius: '8px', width: '100%'}}>
            <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                Mon compte
            </Typography>
            <Divider   sx={{
                borderColor: '#EF595D',
                my: 1,
                width: '5%',
                borderWidth: '2px',
                marginBottom: '15px',
                marginTop: '15px'
            }} />
        </Box>
        <MainCard>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Tabs
                        value={value}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChange}
                        aria-label="simple tabs example"
                        variant="scrollable"
                        sx={{
                            mb: 3,
                            '& a': {
                                minHeight: 'auto',
                                minWidth: 10,
                                py: 1.5,
                                px: 1,
                                mr: 2.25,
                                color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.900',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textTransform: 'none'
                            },
                            '& a.Mui-selected': {
                                color: theme.palette.primary.main
                            },
                            '& .MuiTabs-indicator': {
                                bottom: 2
                            },
                            '& a > svg': {
                                marginBottom: '0px !important',
                                mr: 1.25
                            }
                        }}
                    >
                        {tabsOption.map((tab, index) => (
                            <Tab key={index} component={Link} to="#" icon={tab.icon} label={tab.label} {...a11yProps(index)} />
                        ))}
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        <PersonnalDataEditForm account={account}
                                               editMode={editMode}
                                               setEditMode={setEditMode}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Grid container spacing={gridSpacing}>
                        <EmailEditForm account={account} />
                        <PasswordEditForm account={account} />
                        </Grid>
                    </TabPanel>
                </Grid>
            </Grid>
        </MainCard>
        </DefaultLayout>
    );
};

export default Profile;
